interface FormSectionProps {
  title: string
  children: React.ReactNode
}

export function FormSection({ title, children }: FormSectionProps) {
  return (
    <fieldset className="space-y-4">
      <legend className="text-sm font-semibold text-foreground pb-2 border-b border-border w-full">
        {title}
      </legend>
      {children}
    </fieldset>
  )
}
